import { IconBell, IconHelpCircle, IconPlus, IconSearch, IconSidebar } from 'featherico';
import moment from 'moment';
import triggerPopupAlert from '../../react/components/PopupAlert/trigger';
import GlobalCreate from '../../react/features/AppHeader/components/GlobalCreate';
import { HelpMenu, useReleaseNotes } from '../../react/features/AppHeader/components/HelpMenu';
import UserMenu from '../../react/features/AppHeader/components/UserMenu';
import { NavItemButton } from '../../react/features/Navigation/Item';
import { useAppContext } from '../../react/hooks/useAppContext';
import { useNow } from '../../react/hooks/useNow';
import styles from './style.m.less';

type Props = {
    onExpand: () => void;
};

const showNotImplementedAlert = () => triggerPopupAlert('Not implemented in the compact navigation yet.', 'error');

export default function ActionsCompact({ onExpand }: Props) {
    const { user } = useAppContext();
    const now = useNow(moment.duration(1, 'hour'));
    const releaseNotes = useReleaseNotes(user, now);
    const menuPlacement = 'right-end';
    return (
        <div className={styles.container}>
            <div className={styles.section}>
                {!user.isGuest && (
                    <GlobalCreate
                        user={user}
                        trigger={<NavItemButton icon={<IconPlus />} label="Create" compact />}
                        placement={menuPlacement}
                    />
                )}
                <NavItemButton icon={<IconSearch />} label="Search" compact onClick={showNotImplementedAlert} />
                <HelpMenu
                    user={user}
                    now={now}
                    releaseNotes={releaseNotes}
                    trigger={
                        <NavItemButton
                            icon={<IconHelpCircle />}
                            label="Help"
                            notification={releaseNotes.hasNewReleaseNotes ? { count: 1, type: 'INFO' } : undefined}
                            compact
                        />
                    }
                    placement={menuPlacement}
                />
                <NavItemButton icon={<IconBell />} label="Notifications" compact onClick={showNotImplementedAlert} />
            </div>
            <div className={styles.section}>
                <NavItemButton icon={<IconSidebar />} label="Expand Navigation" compact onClick={onExpand} />
                <UserMenu user={user} compact />
            </div>
        </div>
    );
}
